// extracted by mini-css-extract-plugin
export default {"Burst":"Burst-styles__Burst__M94SU","Burst__Animated":"Burst-styles__Burst__Animated__nBI2s","burst":"Burst-styles__burst__fJZ5F"};